export const NUMBER = 0;
export const LETTER = 1;
export const BMI = 2;
